import {
  WORK_SCHEDULE_WEEKLY_EVENTS_REQUEST,
  WORK_SCHEDULE_WEEKLY_EVENTS_RECEIVED,
  WORK_SCHEDULE_WEEKLY_EVENTS_ERROR,
  WORK_SCHEDULE_WEEKLY_EVENTS_UNLOAD,
  WORK_SCHEDULE_WEEKLY_EVENTS_SET_DATE,
} from '../constants';

import { requests } from '../../helper/agent';
import * as API_ROUTES from '../../routing/api';
import { userLogout } from './user';
import { SubmissionError } from 'redux-form/lib/SubmissionError';
import { parseApiErrors } from '../../helper/apiUtils';
import moment from 'moment';

export const workScheduleWeeklyEventsRequest = () => ({
  type: WORK_SCHEDULE_WEEKLY_EVENTS_REQUEST,
});

export const workScheduleWeeklyEventsReceived = (data) => ({
  type: WORK_SCHEDULE_WEEKLY_EVENTS_RECEIVED,
  data,
});

export const workScheduleWeeklyEventsError = (error) => ({
  type: WORK_SCHEDULE_WEEKLY_EVENTS_ERROR,
  error,
});

export const workScheduleWeeklyEventsUnload = () => ({
  type: WORK_SCHEDULE_WEEKLY_EVENTS_UNLOAD,
});

export const workScheduleWeeklyEventsSetDate = (date) => ({
  type: WORK_SCHEDULE_WEEKLY_EVENTS_SET_DATE,
  date,
});

export const workScheduleWeeklyEventsFetch = (date = moment().utc().format('DD-MM-YYYY')) => {
  return (dispatch) => {
    dispatch(workScheduleWeeklyEventsRequest());
    return requests
      .get(`${API_ROUTES.WORK_SCHEDULE_WEEKLY_EVENTS}`, { date, pagination: false })
      .then((response) => dispatch(workScheduleWeeklyEventsReceived(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        dispatch(workScheduleWeeklyEventsError(error));
      });
  };
};
